import { render, staticRenderFns } from "./childaccounts.vue?vue&type=template&id=36bb16c1"
import script from "./childaccounts.ts?vue&type=script&lang=js&external"
export * from "./childaccounts.ts?vue&type=script&lang=js&external"
import style0 from "./childaccounts.vue?vue&type=style&index=0&id=36bb16c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports